export default {"src":"/_next/static/media/life-insurance.c53feebf.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};